var project = require('../../settings');
var utils = require('./modules/utils');
var Featherlight = require('./lib/featherlight');
var Seamless = require('./lib/seamless');
const Cookies = require('js-cookie')

import CMP from "./modules/CookiebotCMP.class";


/* Event Handlers  */
(function ($, $PB) {
    var $header = $('header.main');
    var $body = $('body');
    new CMP($body, "CookiebotOnConsentReady");
    const pardotAccountID = project.pardotAccountID;

    $(window).on("kmdg_cmp_marketing_consent", function() {
        if(pardotAccountID) {
            Cookies.set(`pi_opt_in${pardotAccountID}`, "true");
            Cookies.set(`pi_opt_in${pardotAccountID-1e3}`, "true");
        }
    });

    $(window).on("kmdg_cmp_no_marketing_consent", function() {
        if(pardotAccountID) {
            Cookies.set(`pi_opt_in${pardotAccountID}`, "false");
            Cookies.set(`pi_opt_in${pardotAccountID-1e3}`, "false");
        }
    });

    $('iframe').each(function(i, el) {
        if($(el).attr('src') && $(el).attr('src').indexOf("//www.respondus.com") > 0) {
            console.log(el);
            $(el).seamless();
        }
    });

    // Automatically equalize height on specified elements
    $(window).on("load", function () {
        utils.equalHeight('.equal', '.builder-section');
        utils.equalHeight('.js-img-equalize', '.builder-layout-blog_blocks');
        utils.equalHeight('.js-equal-overlay', '.builder-layout');
        utils.equalHeight('.js-equal-content', '.builder-layout');
        utils.equalHeight('.js-equal-box', '.builder-layout');
        utils.equalHeight('.js-equal-info', '.builder-layout');
        utils.equalHeight('.js-equal-image', '.builder-layout');
        utils.equalHeight('.js-equal-top', '.builder-layout');
        utils.equalHeight('.js-equal-bot', '.builder-layout');
        utils.equalHeight('.equal', '.posts-wrap');
        $(window).trigger('resize').trigger('scroll');

        setTimeout(function(){

            $(".read_more-loading").removeClass("read_more-loading");

        }, 100);


        setInterval(function() {
            jQuery(window).trigger('resize').trigger('scroll');
        }, 1000);
    });

    $(window).on('load resize', function () {
        $header.addClass('fixed');
        $body.css('margin-top', $header.outerHeight());
    });

    $('.icon-modal__button a').on('click', function(e) {
        var $this = $(this);

        setTimeout(function() {
            $this.parents('.featherlight').find(".featherlight-close").trigger('click')
        }, 1);
    });

    $("#menu-wrapper").mmenu(
        {
            "navbar": {
                "title": mmtitle,
            },
            "navbars": [
                // {
                //     "position": "bottom",
                //     "content": [
                //         "searchfield"
                //     ]
                // }
            ],
            "slidingSubmenus": false,
            "extensions": [
                "theme-dark",
                "position-right",
                "position-front"
            ],
            "searchfield": {
                "search": false,
            },
            classNames: {
                fixedElements: {
                    fixed: "fix",
                    sticky: "stick"
                }
            }
        }, {
            "searchfield": {
                "form": {
                    "method": 'GET',
                    "action": homeurl
                },
                "input": {
                    "name": 's'
                }
            }
        }
    );

    /*$("#menu-wrapper").mmenu({
        "navbar": {
            "title": mmtitle,
        },
        "extensions": [
            "pagedim-black",
            "theme-dark",
            "position-right"
        ],
        classNames: {
            fixedElements: {
                fixed: "fix",
                sticky: "stick"
            }
        }
    });*/

    $( document ).ready(function() {
        $('.builder-layout-full-width-masonry-grid .block-wrap').show();
        $('.builder-component-image-grid .block-wrap').show();
    });

    $('.builder-layout-half-block .rollover').each(function () {
        if ($(this).siblings('.rollover-active').length) {
            $(this).addClass('has-active');
        }
    });

    $('.builder-layout-rollover-section .rollover').each(function () {
        if ($(this).siblings('.rollover-active').length) {
            $(this).addClass('has-active');
        }
    });

    $('.tabs-container ul.tabs-wrap li:first-child').addClass('open');
    $('.tab-outer-wrap .tab-content:first-child').addClass('open');

    $('.tabs-container ul.tabs-wrap li').on('click', function(){
        var $tab_id = $(this).attr('data-tab');

        $('.tabs-container ul.tabs-wrap li').removeClass('open');
        $('.tab-content').removeClass('open');

        $(this).addClass('open');
        $("#"+$tab_id).addClass('open');

    });

    function commaSeparateNumber(val) {
        while (/(\d+)(\d{3})/.test(val.toString())) {
            val = val.toString().replace(/(\d+)(\d{3})/, '$1' + ',' + '$2');
        }
        return val;
    }

    $PB('.builder-component-ticker-counter').on('builderAnimationStart', function() {
        var $this = $(this),
            $number = $this.find('.single-counter .number'),
            countTo = $number.attr('data-count'),
            delay = $this.attr('data-animation-delay') * 1000;

        setTimeout(function () {
            $({
                countNum: 0
            }).animate({
                    countNum: countTo
                },

                {
                    duration: 0,
                    easing: 'linear',
                    step: function() {
                        $number.text(commaSeparateNumber(Math.floor(this.countNum)));
                    },
                    complete: function() {
                        $number.text(commaSeparateNumber(this.countNum));
                    }
                }
            );
        }, delay);
    });

    $(".single-accordion .accordion-header").on("click", function () {
        var $column = $(this).parent();

        $column.toggleClass("open");
        $column.find(".accordion-inner").slideToggle({
            duration: 200,
            complete: function() {
                if($column.hasClass('open')) {
                    try {
                        $column.find('.flexslider').flexslider();
                    } catch (e) {
                        console.log("failed to init slider");
                    }
                }
            }
        });
    });

    $('.builder-section.read_more').each(function(i, el) {
        $(el).find(".builder-layout").not(":nth-child(-n+2)").wrapAll('<div class="builder-expandable" />')
    });

    $(".builder-section.read_more .load_more, .builder-section.read_more .view_less").on("click", function (){
        var $show = $(this).parent();

        $show.toggleClass("show");

        $show.find(".builder-expandable").slideToggle({
            duration: 200,
            complete: function() {
                utils.equalHeight('.js-equal-info', '.builder-layout');
            }
        });
    });

    $('.footer-form-container .contact-btn').on('click', function() {
        var $show = $(this).parent();

        $show.find('.footer-form-form').slideToggle({
            duration: 400
        });
    });

    // $(".blog .load-more-news .load-more-btn").on("click", function (){
    //     var $load = $(this).parent();
    //
    //     $load.addClass("show");
    //     $load.find(".builder-layout").not(":first").slideToggle({
    //         duration: 200
    //     });
    // });

    //$(".blog article:nth-child(1n + 6)").css("display", "none");

    $(".gfield_required").text(function(i, text) {
       return text.slice(0, -10);
    });

    function youtube_parser(url){
        var regExp = /^(?:(?:https|http):\/\/)?(?:www\.)?(?:youtube\.com|youtu\.be).*(?<=\/|v\/|u\/|embed\/|shorts\/|watch\?v=)(?<!\/user\/)(?<id>[\w\-]{11})(?=\?|&|$)/;
        var match = url.match(regExp);
        return (match&&match[1].length >= 11)? match[1] : false;
    }

    $('a').each(function(i, el) {
        var url = $(el).attr("href");

        if(url) {
            //console.log(url, url.indexOf('.pdf'), $(el).find('img'));
            if(url.indexOf("youtube.com/watch?v=") >= 0 || url.indexOf("youtu.be/") >= 0 || (url.indexOf("youtube.com/embed/") >= 0)) {
                // use url.indexOf() to look for youtube embed urls
                // apply featherlight on those tags

                var id = youtube_parser(url);
                $(el).attr("data-featherlight", "iframe")
                    .attr("data-featherlight-iframe-width", "850")
                    .attr("data-featherlight-iframe-height", "468")
                    .attr("data-featherlight-iframe-frameborder", "0")
                    .attr("data-featherlight-iframe-allow", "autoplay; encrypted-media")
                    .attr("data-featherlight-iframe-allowfullscreen", "true")
                    .attr("href", "//www.youtube-nocookie.com/embed/" + id + "?rel=0&amp;autoplay=1" );

                $(el).featherlight();
                return;
            }

            if(url.indexOf('.pdf') >= 0 || url.indexOf('.doc') >= 0 || url.indexOf('.docx') >= 0) {
                if($(el).find('img').length <= 0 && $(el).find('div').length <= 0) {
                    if($(el).parents("li").length <= 0) {
                        $(el).addClass('icon');
                    }
                    return;
                }
            }
        }
    });

})(jQuery, KMDGPB.jQuery);